var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreatedTransactionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 106,
    viewBox: "0 0 127 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.35 55.05C122.35 69.25 116.55 82.05 107.25 91.25C98.1502 100.35 85.5502 105.85 71.6502 105.85C57.8502 105.85 45.2502 100.25 36.0502 91.25C26.7502 82.05 20.9502 69.25 20.9502 55.05C20.9502 26.95 43.6502 4.25 71.6502 4.25C99.6502 4.25 122.35 27.05 122.35 55.05Z",
    fill: "#0078FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.95 21.7498C120.214 21.7498 122.05 19.9142 122.05 17.6498C122.05 15.3854 120.214 13.5498 117.95 13.5498C115.686 13.5498 113.85 15.3854 113.85 17.6498C113.85 19.9142 115.686 21.7498 117.95 21.7498Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.95 5.7499C125.496 5.7499 126.75 4.4963 126.75 2.9499C126.75 1.4035 125.496 0.149902 123.95 0.149902C122.404 0.149902 121.15 1.4035 121.15 2.9499C121.15 4.4963 122.404 5.7499 123.95 5.7499Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.55 21.6498C24.0964 21.6498 25.35 20.3962 25.35 18.8498C25.35 17.3034 24.0964 16.0498 22.55 16.0498C21.0036 16.0498 19.75 17.3034 19.75 18.8498C19.75 20.3962 21.0036 21.6498 22.55 21.6498Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45 75.65C8.32188 75.65 10.65 73.3219 10.65 70.45C10.65 67.5781 8.32188 65.25 5.45 65.25C2.57812 65.25 0.25 67.5781 0.25 70.45C0.25 73.3219 2.57812 75.65 5.45 75.65Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.25 28.4497V91.2497C98.1498 100.35 85.5498 105.85 71.6498 105.85C57.8498 105.85 45.2498 100.25 36.0498 91.2497V28.4497H107.25Z",
    fill: "url(#paint0_linear_17024_47798)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.9079 60.5036L58.978 46.5737L54.2405 51.3113L68.1703 65.2412L72.9079 60.5036Z",
    fill: "#40C36D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M84.3332 39.6488L63.5444 60.4375L68.282 65.1751L89.0707 44.3863L84.3332 39.6488Z",
    fill: "#40C36D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8502 73.75H53.4502V78.35H89.8502V73.75Z",
    fill: "#D5DAE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8502 83.8501H53.4502V88.4501H89.8502V83.8501Z",
    fill: "#D5DAE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9501 94.0498H62.3501V98.6498H80.9501V94.0498Z",
    fill: "#D5DAE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17024_47798",
    x1: 109.5,
    y1: 17,
    x2: 31.4998,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE1ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedTransactionIcon);
export default __webpack_public_path__ + "static/media/CreatedTransactionIcon.b3850394.svg";
export { ForwardRef as ReactComponent };